import Yup from 'utils/validation/yup-extensions';
import { isDateStringGreaterThan } from 'utils';

/**
 * List of "steps"
 */
export const DELEGATE_STEPS = {
	SELECT_DELEGATEE: 'Select Delegatee',
	SELECT_USERS: 'Select User(s)',
	SELECT_DATES: 'Pick Dates',
	ACTION_SUMMARY: 'Review & Submit',
};

/**
 * Keys to be used by Formik for Delegate form
 */
export const DELEGATE_FIELD_KEYS = {
	DELEGATEE: 'delegatee',
	USERS_LIST: 'usersList',
	START_DATE: 'startDate',
	END_DATE: 'endDate',
};

/**
 * mapping of the fields and which step index they belong to
 */
export const DELEGATE_FIELD_STEPS = {
	0: [DELEGATE_FIELD_KEYS.DELEGATEE],
	1: [DELEGATE_FIELD_KEYS.USERS_LIST],
	2: [DELEGATE_FIELD_KEYS.START_DATE, DELEGATE_FIELD_KEYS.END_DATE],
};

/**
 * Form field metadata (default values, validation schema)
 */
export const DELEGATE_FIELDS = {
	[DELEGATE_FIELD_KEYS.DELEGATEE]: {
		defaultValue: [],
		validationSchema: Yup.array().length(
			1,
			'You must select one and only one delegatee.'
		),
		stepLocation: DELEGATE_STEPS.SELECT_DELEGATEE,
		reviewLabel: 'Select Delegatee',
	},
	[DELEGATE_FIELD_KEYS.USERS_LIST]: {
		defaultValue: [],
		validationSchema: Yup.array()
			.min(1, 'Please select a user.')
			.test('Is Delegatee Selected', function (values) {
				const delegateeIds = this.parent[
					DELEGATE_FIELD_KEYS.DELEGATEE
				].map(d => d.fiId);
				if (values.some(v => delegateeIds.includes(v.fiId))) {
					return this.createError({
						message:
							'The delegatee may not be permitted to review themselves. Please ensure your delegatee selection is not also selected here.',
					});
				}
				return true;
			}),
		stepLocation: DELEGATE_STEPS.SELECT_USERS,
		reviewLabel: 'Select User(s)',
	},
	[DELEGATE_FIELD_KEYS.START_DATE]: {
		defaultValue: null,
		validationSchema: Yup.date()
			.required('Please specify a start date')
			.max(
				new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
				'The date provided is more than one year in the future.'
			)
			.min(
				new Date(new Date().setHours(0, 0, 0, 0)),
				'The date provided is not in the future.  Please provide a future date.'
			),
		stepLocation: DELEGATE_STEPS.SELECT_DATES,
		reviewLabel: 'Date to start delegation',
	},
	[DELEGATE_FIELD_KEYS.END_DATE]: {
		defaultValue: null,
		validationSchema: Yup.date()
			.required('Please specify an end date')
			.max(
				new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
				'The date provided is more than one year in the future.'
			)
			.min(
				new Date(new Date().setHours(0, 0, 0, 0)),
				'The date provided is not in the future.  Please provide a future date.'
			)
			.test('Is End After Start', function (end) {
				if (
					isDateStringGreaterThan(
						this.parent[DELEGATE_FIELD_KEYS.START_DATE],
						end
					)
				) {
					return this.createError({
						message:
							'The date needs to be after the start date provided above.',
					});
				}
				return true;
			}),
		stepLocation: DELEGATE_STEPS.SELECT_DATES,
		reviewLabel: 'Date to end delegation',
	},
};
